module.exports = __webpack_public_path__ + "static/media/logo-2.7e17004b.svg";